import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnCircleAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M11.996 8v4.887M11.99 16h.008M12 21c4.95 0 9-4.05 9-9s-4.05-9-9-9-9 4.05-9 9 4.05 9 9 9"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnCircleAlert;
